import { createSlotsContext } from "@grandvisionhq/slots";
const [ProductDetailSlotsProvider, useProductDetailSlots] = createSlotsContext({
  displayName: "ProductDetailSlotsContext"
});
const [ProductDetailLayoutSlotsProvider, useProductDetailLayoutSlots] = createSlotsContext({
  displayName: "ProductDetailLayoutSlotsContext"
});
export {
  ProductDetailLayoutSlotsProvider,
  ProductDetailSlotsProvider,
  useProductDetailLayoutSlots,
  useProductDetailSlots
};
//# sourceMappingURL=context.js.map
